import { Component, OnInit } from '@angular/core';

import { CmsServerService } from 'src/app/services/jsonrpc/cms-server.service';
import { CmsService } from 'src/app/services/cms.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
})
export class ConfigurationComponent implements OnInit {
  public rules: any = [];
  public edit = [];
  public wikiColors = [];
  public appColors = {};

  public newName = environment.name;
  public newShortName = environment.short_name;

  public get name() {
    return environment.name;
  }
  public get shortName() {
    return environment.short_name;
  }

  constructor(private cms: CmsService, private server: CmsServerService) {}

  public ngOnInit() {
    this.updateData();
  }

  public changeNames(name: boolean, short_name: boolean) {
    environment.name = name ? this.newName : this.name;
    environment.short_name = short_name ? this.newShortName : this.shortName;

    this.cms.updateConfig();

    return this.updateApp();
  }

  public changeLabel(depth: number, name: string) {
    environment.tree.rules[depth].label = name;
    return this.server.configUpdateTree({ depth, config: environment.tree.rules[depth] }).then(() => this.updateData());
  }

  public changeMenuFeatures(depth: number, features: any) {
    environment.tree.rules[depth].menuFeatures = features;
    return this.server.configUpdateTree({ depth, config: environment.tree.rules[depth] }).then(() => this.updateData());
  }

  public uploadMenuFeatureSlides(event: any[], depth: number) {
    const slides = {
      slides: event.map(s => ({
        headline: s.headline,
        text: s.text,
        image: s.image,
        link: s.link,
        externalLink: s.externalLink,
        imageAnchor: s.imageAnchor
      }))
    };
    return this.changeMenuFeatures(depth, slides);
  }

  public updateWikiColors(colors) {
    this.wikiColors = colors;

    const colorIds = Object.keys(environment.wiki.colors);

    for (const [index, id] of colorIds.entries()) {
      environment.wiki.colors[id] = this.wikiColors[index];
    }

    this.cms.updateConfig();

    return this.updateApp();
  }

  public updateAppColors(colors) {
    this.appColors = { ...this.appColors, ...colors };
    environment.app = { ...environment.app, colors: this.appColors };
    this.cms.updateConfig();

    return this.updateApp();
  }

  private updateApp() {
    return this.server
      .configUpdateApp({
        name: environment.name,
        short_name: environment.short_name,
        app: environment.app as any,
        wiki: environment.wiki as any
      })
      .then(() => this.updateData());
  }

  private updateData() {
    this.wikiColors = Object.values(environment.wiki.colors);
    this.appColors = environment.app?.colors ? environment.app.colors : {};
    this.rules = environment.tree.rules
      .filter(r => !r.modifier)
      .map(r => {
        return {
          ...r,
          newLabel: r.label
        };
      });
  }
}
